import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface ISignUpCTAProps {
  disabled?: boolean;
  handleSubmit: () => void;
  isFaireDirectSignUp?: boolean;
}

export const SignUpCTA: React.FC<ISignUpCTAProps> = ({
  disabled,
  handleSubmit,
  isFaireDirectSignUp,
}) => {
  return (
    <Button
      onClick={handleSubmit}
      data-test-id="createAccountButton"
      style={{ width: "100%" }}
      disabled={disabled}
      variant="primary"
    >
      <SignUpCopy isFaireDirectSignUp={isFaireDirectSignUp} />
    </Button>
  );
};

const SignUpCopy: React.FC<Pick<ISignUpCTAProps, "isFaireDirectSignUp">> = ({
  isFaireDirectSignUp,
}) => {
  if (isFaireDirectSignUp) {
    return (
      <StrictLocalMsg
        defaultMessage="Sign up"
        description={{
          text: "Call to action to begin the sign up flow (CTA button text)",
          img: "https://cdn.faire.com/fastly/0c705d043798ad67c119f649b03bfcea3e780aef74af6047e57fb743e6dc643d.png",
        }}
      />
    );
  }

  return <SignUpForFreeMessage />;
};

const SignUpForFreeMessage = () => {
  return (
    <StrictLocalMsg
      defaultMessage="Sign up for free"
      description={{
        text: "Call to action to begin the sign up flow (CTA button text)",
        img: "https://cdn.faire.com/fastly/b4af2f5790b4e0752944ac056de2906b679cd6fd241b5101f29e827cc2523f2f.png",
      }}
    />
  );
};
